import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { ReactComponent as LineSvg } from '@/assets/images/home/line-bg.svg';

// CONSTANTS
import { LOCATIONS_HOME_PAGE } from '@/constants/locations';

// COMPONENTS
import Loader from '@/components/Loader';

// HELP
import FeatureCard from './help/FeatureCard';

// STYLES
import AboutCoolFeaturesSection from './styles';

const getFeaturesData = t => [
  {
    img: {
      src: `${process.env.REACT_APP_CLOUDFRONT_LINK}/assets/images/tvshow-and-movies.png`,
      srcSet: `${process.env.REACT_APP_CLOUDFRONT_LINK}/assets/images/tvshow-and-movies.webp`,
    },
    title: t('home.aboutCoolFeatures.showsAndMovies.title'),
    desc: t('home.aboutCoolFeatures.showsAndMovies.desc'),
    link: {
      href: '/shows-and-movies',
      title: t('home.aboutCoolFeatures.showsAndMovies.link.title'),
    },
  },
  {
    img: {
      src: `${process.env.REACT_APP_CLOUDFRONT_LINK}/assets/images/manage-apps.png`,
      srcSet: `${process.env.REACT_APP_CLOUDFRONT_LINK}/assets/images/manage-apps.webp`,
    },
    title: t('home.aboutCoolFeatures.apps.title'),
    desc: t('home.aboutCoolFeatures.apps.desc'),
    link: {
      href: '/discover',
      title: t('home.aboutCoolFeatures.apps.link.title'),
    },
  },
];

function AboutCoolFeatures({ loading }) {
  const [t] = useTranslation();

  const data = React.useMemo(() => getFeaturesData(t), [t]);

  return (
    <AboutCoolFeaturesSection className="section about-cool-features">
      <LineSvg className="about-cool-features__bg-line" />
      <div className="page-content">
        <Grid container spacing={5} alignItems="center">
          <Grid item xs={12}>
            <Typography
              className="about-cool-features__title"
              variant="h3"
              component="h2"
              align="center"
            >
              {t('home.aboutCoolFeatures.title')}
            </Typography>
            <Typography className="about-cool-features__subtitle p4" align="center">
              {t('home.aboutCoolFeatures.subtitle')}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={5} justifyContent="center">
              {data.map((itemData, idx) => (
                <Grid key={idx} item xs={12} sm={6}>
                  <FeatureCard data={itemData} analyticsLocation={LOCATIONS_HOME_PAGE} />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
        <Loader active={loading} />
      </div>
    </AboutCoolFeaturesSection>
  );
}

AboutCoolFeatures.propTypes = {
  content: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};

export default AboutCoolFeatures;
